export default {
  state: {
    mtech: {
      enabled: false,
      services: [],
      markup: {
        type: '%',
        value: 0
      },
      flightDate: '',
      isDomestic: true,
      pickupDate: '',
      quoteId: '',
      details: {
        localPickupDate: '',
        timezone: '',
        service: {}
      }
    }
  },
  mutations: {
    setMtechData (state, data) {
      for (let field in data) {
        state.mtech[field] = data[field]
      }
    },
    setMtechNewPricing (state, data) {
      if (
        !Object.keys(state.mtech.services).length ||
        !state.mtech.services[data.code]
      ) {
        return
      }

      state.mtech.services[data.code].price = data.val
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/reservation-details/mtech.js